import * as React from "react";
const SvgFiRrShovelSnow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shovel-snow_svg__a)">
      <path
        fill="#062147"
        d="m23.708 4.293-4-4a.999.999 0 1 0-1.414 1.414L19.587 3l-8.32 8.32-1.525-1.526a4.005 4.005 0 0 0-5.657 0L.88 13a3.003 3.003 0 0 0 0 4.243l5.88 5.88a3 3 0 0 0 2.121.876c.77 0 1.536-.292 2.121-.877l3.207-3.206a3.97 3.97 0 0 0 1.172-2.829 3.97 3.97 0 0 0-1.173-2.828l-1.525-1.525 8.32-8.319 1.293 1.293a.997.997 0 0 0 1.413 0 1 1 0 0 0 0-1.414m-10.33 12.794c0 .535-.207 1.037-.585 1.415l-3.207 3.206c-.39.39-1.025.39-1.415 0l-.747-.747 3.28-3.25a1.001 1.001 0 0 0-1.41-1.42l-3.286 3.255-1.585-1.585 3.28-3.25a1.001 1.001 0 0 0-1.41-1.42l-3.286 3.255-.717-.717a1 1 0 0 1 0-1.415l3.206-3.206c.39-.39.902-.585 1.415-.585s1.024.195 1.414.585l4.466 4.465c.377.378.585.88.585 1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shovel-snow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShovelSnow;
